import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import LimitesLCTCTabla from './LimitesLCTCTabla'
import { OperacionLCTCLimitesAprobadosUnidadNegocio } from '../../sistema/sistemas/lctc/types/dto'
import { OperacionLCTCLimitesAprobadosUnidadNegocioFields } from '../../sistema/sistemas/lctc/types/fields'

interface LimiteLCTCUnidadNegocioProps {
    data: OperacionLCTCLimitesAprobadosUnidadNegocio
}

function LimiteLCTCUnidadNegocio({ data }: LimiteLCTCUnidadNegocioProps) {
    const unidadNegocioCodigo = data[OperacionLCTCLimitesAprobadosUnidadNegocioFields.DescUnidadNegocio]

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`panel-${unidadNegocioCodigo}-header`}>
                <Typography variant="h6" component="h3">
                    Unidad de Negocio: {unidadNegocioCodigo}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, pb: 0 }}>
                <LimitesLCTCTabla limites={data[OperacionLCTCLimitesAprobadosUnidadNegocioFields.ListaLimites]} />
            </AccordionDetails>
        </Accordion>
    )
}

export default LimiteLCTCUnidadNegocio
